<template>
    <div>
        <div class="contentMenu">
            <div class="menuItem" @click="changeSection('act')" :class="{'active': section === 'act'}">Akta informācija</div>
            <div class="menuItem" @click="changeSection('items')" :class="{'active': section === 'items'}">Priekšmeti</div>
        </div>
        <div class="content">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="main">
                <div v-if="section=='act'" class="section">
                    <div class="sectionTitle">Izslēgšanas akta pamatdati</div>
                    <div class="sectionContent">
                        <div class="subsection">
                            <div class="title">
                                Pamatinformācija
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_number">Rīkojuma numurs</label>
                                    <input type="text" id="act_number" v-model="act_number" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_date">Rīkojuma datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="act_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_number">Kartītes status</label>
                                    <div>
                                        <span class="badge-pill badge-light" v-if="act_status == 'project'">Izslēgšanas projekts</span>
                                        <span class="badge-pill badge-danger" v-if="act_status == 'done'">Izslēgšana noslēgta</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="description">Apraksts</label>
                                    <textarea name="description" id="description" rows="5" v-model="description" class="form-control">{{description}}</textarea>
                                    <small class="muted">Neobligāts apraksts</small>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <button class="btn btn-primary" @click="save()">Saglabāt</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="section=='items'" class="section">
                    <div class="sectionTitle">Priekšmeti</div>
                    <div class="sectionContent">
                        <div class="actions">
                            <items-search-component></items-search-component>
                        </div>
                        <div class="fixedHeight">
                        <table class="table">
                            <thead class="bg-primary text-white">
                            <tr>
                                <th>Attēls</th>
                                <th>Numurs</th>
                                <th>Nosaukums</th>
                                <th>Kolekcija</th>
                                <th>Izslēgšanas iemesls</th>
                                <th>Status</th>
                                <th>Darbības</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td style="width:120px;"><img v-if="item.featured_image != null" :src="'/image/thumb/'+item.featured_image.file_name"></td>
                                <td style="width:120px;">
                                    {{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span>
                                </td>
                                <td><span v-if="item.title">{{item.title.title}}</span></td>
                                <td><span v-if="item.collection">{{item.collection.title}}</span></td>
                                <td style="width:250px;">
                                    <textarea type="text" class="form-control" v-model="item.pivot.reason">{{item.pivot.reason}}</textarea>
                                </td>
                                <td><span v-if="item.deleted_at" class="badge-pill badge-danger">Izslēgts</span></td>
                                <td>
                                    <div class="actions">
                                        <item-view-component
                                            :key="'view-component-'+item.id"
                                            :item="item"
                                            :user="user"
                                        ></item-view-component>
                                        <div @click="removeFromList(item.id)" class="delete" ><span class="material-icons">close</span></div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="items.length === 0" class="alert alert-info text-center">Sarakstā nav neviens priekšmets. Izmantojiet <strong>priekšmetu meklētāju</strong>, lai meklētu un pievienotu jaunus priekšmetus.</div>
                        </div>
                        <hr>
                        <div class="text-right">
                            <button class="btn btn-primary" @click="saveItems()">Saglabāt</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sidebar">
                <div class="section">
                    <div class="sectionTitle">Darbības</div>
                    <div class="sectionContent text-center">
                        <button class="btn btn-danger" @click="eliminateItems()">Izslēgt priekšmetus no fonda</button>
                        <hr>
                        <a :href="'/elimination-acts/generate-act/'+id" class="btn btn-primary" target="_blank" >Ģenerēt rīkojuma pielikumu</a>
                    </div>
                </div>
                <div class="section" v-if="section=='items'">
                    <div class="sectionTitle">Pievienošana</div>
                    <div class="sectionContent">
                        <div class="row">
                            <div class="col-12 text-left">
                                <div class="form-group">
                                    <get-from-external-act></get-from-external-act>
                                </div>
                                <div class="form-group">
                                    <get-from-internal-act></get-from-internal-act>
                                </div>
                                <div class="form-group">
                                    <researchers-lists></researchers-lists>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.fixedHeight
{
    max-height:70vh;
    overflow:auto;
    position:relative;
}
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    .action{
        cursor:pointer;
        padding:15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
.content{
    position:relative;
    display:flex;
    .main{
        flex-basis:800px;
        flex-grow:1;
    }
    .sidebar{
        flex-basis:400px;
        flex-grow:0;
        flex-shrink:0;
        margin-left:30px;
    }
}
.section{
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
    margin:15px 0;
    .subsection
    {
        width:100%;
        display:flex;
        align-items: center;
        padding-bottom:5px;
        padding-top:10px;
        border-bottom:solid 5px #eee;
        margin-bottom:15px;
        .title{
            font-size:18px;
            font-weight:bold;
        }
        .actions{
            margin-left:auto;
        }
    }
    hr{
        width:100%;
        display:block;
    }
    .sectionTitle{
        cursor:pointer;
        font-size:16px;
        font-weight: 700;
        text-transform: uppercase;
        padding:15px 20px;
        background-color:$blue;
        color:#fff;
    }
    .sectionContent{
        width:100%;
        padding:10px 20px 20px 20px;
        img{
            width:100px;
            height:auto;
        }
    }
}
</style>

<script>
import ItemViewComponent from "../items/ItemViewComponent";
export default{
    components: {ItemViewComponent},
    props:['act','elimination_acts','current_user','user'],
    mounted()
    {
        this.items=this.$props.act.items;
        this.id=this.$props.act.id;
        this.act_number=this.$props.act.act_number
        this.act_date=moment(this.$props.act.act_date, moment.ISO_8601)._d;
        this.act_status=this.$props.act.act_status;
        this.description=this.$props.act.description;

        var that = this;
        EventBus.$on('add_item_to_list',item_id =>{
            //Should save items data before adding
            that.saveItems(false);
            axios.post('/elimination-acts/add-item-to-list/'+that.id,
                {
                    item_id: item_id
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.act.items;
                    that.$toast.open(response.data.message);
                }
                if(response.data.status == 'info')
                {
                    that.$toast.warning(response.data.message);
                }
                if(response.data.status == 'error')
                {
                    that.$toast.warning(response.data.message);
                }
            });
        });
        EventBus.$on('add_items_to_list',items_ids =>{
            //Should save items data before adding
            that.saveItems(false);
            axios.post('/elimination-acts/add-items-to-list/'+that.id,
                {
                    items_ids: items_ids
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.act.items;
                    that.$toast.open(response.data.message);
                }
            });
        });

        EventBus.$on('open_next_item_view_modal', (current_item_id) =>{
            that.openNextItemViewModal(current_item_id);
        });
        EventBus.$on('open_prev_item_view_modal', (current_item_id) =>{
            that.openPrevItemViewModal(current_item_id);
        });
    },
    methods:{
        changeSection(section)
        {
            this.section = section;
        },
        openPrevItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#view-'+this.items_list[index+1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else {
                $('#view-'+this.items_list[index+1]).modal('hide');
                if(this.pagination.current_page - 1 >0)
                {
                    this.search(this.pagination.current_page-1);
                }

            }
        },
        openNextItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index < this.items_list.length)
            {
                $('#view-'+this.items_list[index-1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else{
                $('#view-'+this.items_list[index-1]).modal('hide');
                if(this.pagination.current_page+1 <= this.pagination.total_page_count)
                {
                    this.search(this.pagination.current_page+1);
                }

            }
        },
        normalDateTime(date)
        {
            return moment(date).format('DD.MM.YYYY. HH:mm')
        },
        normalDate(date)
        {
            return moment(date).format('DD.MM.YYYY.')
        },
        removeFromList(item_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst priekšmetu no saraksta?',
                text: "Priekšmets tiks dzēsts no saraksta.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        //Should save informaction before removing
                        that.saveItems(false);
                        axios.post('/elimination-acts/remove-item-from-list/' + that.id,
                            {
                                item_id: item_id
                            }).then(response => {
                            if (response.data.status == 'ok') {
                                that.items = response.data.act.items;
                                that.$toast.open(response.data.message);
                            }
                            if (response.data.status == 'info') {
                                that.$toast.warning(response.data.message);
                            }
                            if (response.data.status == 'error') {
                                that.$toast.error(response.data.message);
                            }
                        });
                    }});
        },

        eliminateItems()
        {
            //save all data before elimination
            this.saveItems(false);
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties izslēgt priekšmetus no fonda?',
                text: "Priekšmeti tiks neatgriezeniski izslēgt no fonda. Tos vairs nebūs iespējams dzēst no izslēgšanas akta sarakasta.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Izslēgt no fonda',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                if (result.value) {
                    var that = this;
                    axios.post('/elimination-acts/eliminate-items/' + that.id, {
                        items: that.items,
                    }).then(response => {
                        if (response.data.status === 'ok') {
                            that.$toast.open(response.data.message);
                        }
                        if (response.data.status === 'error') {
                            that.$toast.error(response.data.message);
                        }
                    });
                }});
        },

        saveItems(showStatus = true)
        {
            var that = this;
            axios.post('/elimination-acts/save-items/'+that.id,{
                items: that.items,
            }).then(response =>{
                if(response.data.status === 'ok' && showStatus == true)
                {
                    that.$toast.open(response.data.message);
                }
                if(response.data.status === 'error' && showStatus == true)
                {
                    that.$toast.error(response.data.message);
                }
            });
        },
      save()
      {
          var that = this;
          var data = {
              act_number: this.act_number,
              act_date: this.act_date,
              act_status: this.act_status,
              description: this.description
          }
          axios.post('/elimination-acts/update/'+that.id, data).then(response =>{
              if(response.data.status == 'ok')
              {
                  that.loading = false;
                  that.$toast.open(response.data.message);
              }
              else {
                  that.$toast.error(response.data.message);
              }
          });

      }
    },
    data()
    {
        return{
            id:"",
            act_number:"",
            act_date:"",
            act_status:"",
            description:"",
            items:[],
            loading:false,
            section:'act'

        }
    },
    computed:{
        items_list()
        {
            var that = this;
            if(that.items)
            {
                return that.items.map(item =>{
                    return item.id;
                });

            }
        }

    }
}
</script>
